import React from "react";
import "../../ingredientDetails/IngredientDetails.scss";
import { Dimmer, Image, Loader, Message } from "semantic-ui-react";
import { useGetMappingImageUri } from "../../../../api/drawingTool";
import { MappingSourceType } from "../../../../config/enums/MappingSourceType.enum";
import { IngredientDataType } from "../../../../config/enums/IngredientType.enum";

const IngredientMappingTab = ({ ingredientDetails }: any) => {
  const isSupplier =
    ingredientDetails?.supplierIngredientDetails?.data_type ===
    IngredientDataType.SUPPLIER;

  const imageKey = isSupplier
    ? ingredientDetails?.supplierIngredientDetails?.product_summary?.imageKey
    : ingredientDetails?.supplierIngredientDetails?.bom_summary?.imageKey;

  const { data: signedUrlData, isLoading } = useGetMappingImageUri(
    MappingSourceType.product,
    imageKey
  );

  if (imageKey && isLoading) {
    return (
      <Dimmer active>
        <Loader content="Loading" />
      </Dimmer>
    );
  }

  return (
    <>
      {signedUrlData ? (
        <div className="mappingBox">
          <Image src={signedUrlData?.signedUrl} size="huge" rounded />
        </div>
      ) : (
        <Message color="yellow">
          No Supply Chain Mapping for this ingredient.
        </Message>
      )}
    </>
  );
};

export default IngredientMappingTab;
